import { Injectable, inject } from '@angular/core';
import {
  ICreateCategoria,
  IListado,
  IQueryParam,
  IReemplazoCategoria,
  IUpdateCategoria,
  ICategoria,
  IUsoCategoria,
} from 'modelos/src';
import { Observable } from 'rxjs';
import { HelperService } from '../../auxiliares/servicios/helper.service';
import { HttpApiAdminService } from '../../auxiliares/servicios/http-api.service';

@Injectable({
  providedIn: 'root',
})
export class CategoriasService {
  private http = inject(HttpApiAdminService);
  private helper = inject(HelperService);

  public listar(queryParams?: IQueryParam): Observable<IListado<ICategoria>> {
    const params = this.helper.getQueryParams(queryParams);
    return this.http.get(`/categorias`, { params });
  }

  public listarPorId(id: string): Observable<ICategoria> {
    return this.http.get(`/categorias/${id}`);
  }

  public crear(dato: ICreateCategoria): Observable<ICategoria> {
    return this.http.post(`/categorias`, dato);
  }

  public editar(id: string, dato: IUpdateCategoria): Observable<ICategoria> {
    return this.http.put(`/categorias/${id}`, dato);
  }

  /** Quién usa la categoría, abierto por cliente. Alimenta el diálogo de reemplazo. */
  public uso(id: string): Observable<IUsoCategoria> {
    return this.http.get(`/categorias/${id}/uso`);
  }

  /**
   * Borra la categoría reasignando antes a los vecinos que la tengan vigente.
   *
   * Como las categorías son globales, `reemplazos` lleva una entrada por cliente: dos clientes
   * que compartan la categoría pueden mandar a sus vecinos a categorías distintas.
   */
  public eliminarConReemplazos(
    id: string,
    reemplazos: IReemplazoCategoria[],
  ): Observable<ICategoria> {
    return this.http.post(`/categorias/${id}/eliminar`, { reemplazos });
  }

  /**
   * @deprecated Usar {@link eliminarConReemplazos}. Sin reemplazos el backend rechaza con 409
   * apenas la categoría tenga algún vecino vigente.
   */
  public eliminar(id: string): Observable<ICategoria> {
    return this.http.delete(`/categorias/${id}`);
  }
}
